import { clientEnvModule } from "@/modules/client-env";
import { electronModule } from "@/modules/electron";
import { logger } from "@/modules/logger";
import { URL } from "url";

export const navigateToInternalWindowUrl = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToInternalWindowUrl] Navigating.",
    info: { url: url.toString(), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToInternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.replace(url.toString());
  return;
};

export const navigateToExternalWindowUrl = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToExternalWindowUrl] Navigating.",
    info: { url: url.toString(), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToExternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.replace(url.toString());
  return;
};

export const openWindowUrlInNewTab = async ({ url }: { url: URL }): Promise<Window | null> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][openWindowUrlInNewTab] Navigating.",
    info: { url: url.toString(), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToExternalUrl({ url });
    return null;
  }

  // eslint-disable-next-line no-restricted-properties
  const windowProxy = window.open(url.toString(), "_blank");

  return windowProxy;
};

export const navigateToWindowUrlAndRefresh = async ({ url }: { url: URL }): Promise<void> => {
  const isDesktop = clientEnvModule.isDesktop();

  logger.debug({
    message: "[windowModule][navigateToWindowUrlAndRefresh] Navigating.",
    info: { url: url.toString(), isDesktop },
  });

  if (isDesktop) {
    await electronModule.navigateToInternalUrl({ url });
    return;
  }

  // eslint-disable-next-line no-restricted-properties
  window.location.assign(url.toString());
};
